export default "__VITE_PUBLIC_ASSET__132a656b__"